import { createBrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import Hero from "./sections/Hero.jsx";
import Services from "./sections/Services.jsx";
import Portfolio from "./sections/Portfolio.jsx";
import About from "./sections/About.jsx";
import Contact from "./sections/Contact.jsx";
import Login from "./pages/Login.jsx";
import ProjectsRepoPage from "./pages/ProjectsRepoPage.jsx";
import ProjectDetailPage from "./pages/ProjectDetailPage.jsx";
import AdminGuard from "./components/admin/AdminGuard.jsx";
import AdminLayout from "./pages/admin/AdminLayout.jsx";
import Dashboard from "./pages/admin/Dashboard.jsx";
import HeroImagesPage from "./pages/admin/HeroImagesPage.jsx";
import PortfolioPage from "./pages/admin/PortfolioPage.jsx";
import ProjectsPage from "./pages/admin/ProjectsPage.jsx";
import ClientsPage from "./pages/admin/ClientsPage.jsx";
import ServicesPage from "./pages/admin/ServicesPage.jsx";
import ClientGuard from "./components/portal/ClientGuard.jsx";
import PortalLayout from "./pages/portal/PortalLayout.jsx";
import ClientDashboard from "./pages/portal/ClientDashboard.jsx";

/* Vista "Proyectos": casos destacados (Portafolio) + repositorio completo */
function ProyectosView() {
  return (
    <>
      <Portfolio />
      <ProjectsRepoPage />
    </>
  );
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Hero /> },
      { path: "proyectos", element: <ProyectosView /> },
      { path: "proyectos/:id", element: <ProjectDetailPage /> },
      { path: "servicios", element: <Services /> },
      { path: "nosotros", element: <About /> },
      { path: "contacto", element: <Contact /> },
      { path: "login", element: <Login /> },
    ],
  },
  {
    path: "/portal",
    element: <ClientGuard />,
    children: [
      {
        element: <PortalLayout />,
        children: [{ index: true, element: <ClientDashboard /> }],
      },
    ],
  },
  {
    path: "/admin",
    element: <AdminGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Dashboard /> },
          { path: "hero", element: <HeroImagesPage /> },
          { path: "portafolio", element: <PortfolioPage /> },
          { path: "proyectos", element: <ProjectsPage /> },
          { path: "servicios", element: <ServicesPage /> },
          { path: "clientes", element: <ClientsPage /> },
        ],
      },
    ],
  },
]);
